import { render, staticRenderFns } from "./SubscriptionResourcesDetailsGrid.vue?vue&type=template&id=b9eff26a&scoped=true&"
import script from "./SubscriptionResourcesDetailsGrid.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionResourcesDetailsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionResourcesDetailsGrid.vue?vue&type=style&index=0&id=b9eff26a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9eff26a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9eff26a')) {
      api.createRecord('b9eff26a', component.options)
    } else {
      api.reload('b9eff26a', component.options)
    }
    module.hot.accept("./SubscriptionResourcesDetailsGrid.vue?vue&type=template&id=b9eff26a&scoped=true&", function () {
      api.rerender('b9eff26a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/SubscriptionResourcesDetailsGrid.vue"
export default component.exports